<template>
  <span :class="{'is_create': state === 'CREATED'}" :style="{color: colors[state]}">
    {{$t('order_state.' + state)}}
  </span>
</template>

<script>
export default {
  name: 'orderState',
  props: {
    state: {
      default: '',
    }
  },
  data() {
    return {
      colors: {
        CREATED: '#973c00',
        STORE_SENT: '#05BB52',
        STORE_RECEIVE: '#E3B044',
        OFFICER_CLOSED:'red',
        DONE_CLOSED:'red',
        USER_CLOSED:'red',
        PUSH_REFUSE: 'red',
        EXPIRES: 'red'
      }
    }
  },
  computed: {

  },
}
</script>

<style scoped lang="scss">
  .is_create {
    color: #973c00;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/orderState.vue